module.exports = __webpack_public_path__ + "img/dis06.aa1cebf5.svg";